import React, { useContext, useEffect, useState } from "react";
import {
    TableContainer,
    Table,
    TableBody,
    TableHead,
    TableCell,
    Paper,
    TableRow,
    Checkbox,
    TextField,
    CircularProgress
} from '@mui/material';
import DialogModal from "components/DialogModel/DialogModel";
import { CustomTooltip } from "components/CustomTooltip/CustomTooltip";
import api from "utils/API/api";
import { forceLogout } from "commonFunctions/forceLogout";
import * as msg from "utils/constants/messages";
import { useNavigate } from 'react-router-dom';
import * as c from "utils/constants/constants";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";


const PatientInfo = (props) => {

    const navigate = useNavigate();
    const { data = {}, setDataSave, saveAllData, setDocumentData } = useContext(DocumentDetailContext);
    const [selectedPatient, setselectedPatient] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState(false);
    const [loader, setLoader] = useState(true);
    const [patientList, setPatientList] = useState([]);
    const [apiErrorMsg, setApiErrorMsg] = useState(null);

    useEffect(() => {
        if (!data?.MRN && data?.Entity_Details?.extraction?.patientName?.value && data?.Entity_Details?.extraction?.dateOfBirth?.value) {
            setLoader(true);
            getMultiPatientsDetails()
        } else {
            setPatientList([]);
            setLoader(false);
        }

    }, [props.selectedTab]);

    const setPatientID = (event, selected) => {
        let patientInfo = {};
        if (event.target.checked) {
            /*Taking only the keys that are required to be displayed in main screen*/
            patientInfo = {
                "DOB": selected.dob,
                "ID": selected.id,
                "official_name": selected?.name[0],
                "MRN": selected.MRN,
                "confidence": 1
            }
        }
        setselectedPatient(patientInfo);
    };

    const handleChange = (event) => {
        const value = event.target.value;
        const pattern = /^\d+$/;

        setInputValue(value);
        setError(!pattern.test(value));
        if (value == "") setError(false)
    };

    const updatePatientInfo = async () => {
        setLoader(true);
        if (Object.keys(selectedPatient || {})?.length) {
            let res = JSON.parse(JSON.stringify(data));
            res.Entity_Details.patientMatch = selectedPatient
            res.Entity_Details.is_pat_match_found = true
            if (res.Entity_Details.extraction?.patientName) {
                res.Entity_Details.extraction.patientName.value = selectedPatient.official_name;
                res.Entity_Details.extraction.patientName.modified = true;
            }
            if (res.Entity_Details.extraction?.dateOfBirth) {
                res.Entity_Details.extraction.dateOfBirth.value = selectedPatient.DOB;
                res.Entity_Details.extraction.dateOfBirth.modified = true;
            }

            setDataSave(true);
             setDocumentData({...res});
            setLoader(true);
            try {
                let response = await saveAllData('pm');
                if(data.Entity_Details.classify?.documentLevel == "Encounter") props.setSelectedTab(1);
                else if(data.Entity_Details.classify?.documentLevel == "Order") props.setSelectedTab(3);
                else props.setSelectedTab(0);

            } catch(error) {
                console.log(error)
            } finally {
                setDataSave(false);
                setLoader(false)
            }
        }
    }

    const getMultiPatientsDetails = () => {
        setLoader(true);
        setApiErrorMsg(null);
        let query = {
            patient_name: data?.Entity_Details?.extraction?.patientName?.value,
            patient_dob: data?.Entity_Details?.extraction?.dateOfBirth?.value,
        }
        if (inputValue) {
            query = {
                patient_mrn: parseInt(inputValue)
            }
        }

        api
            .getPatientsDetails(query)
            .then((response) => {
                if (response.status === 200) {
                    const { message, data = [] } = response.data
                    setPatientList(data);
                    setLoader(false);
                    setApiErrorMsg(message);
                }
            })
            .catch((error) => {
                setLoader(false);
            });
    };

    return <>
        <div>
            <div>
                <div className="ehr-pt-details">
                    {data?.MRN ? <>
                        <div className="patient-info-title">Patient Details</div>
                        <div className="ehr-pt-each-detail">
                            <div className="ehr-pt-label">MRN</div>
                            <div className="ehr-pt-value">
                                {data.Entity_Details.patientMatch.MRN}
                            </div>
                        </div>
                        <div className="ehr-pt-each-detail">
                            <div className="ehr-pt-label">Name</div>
                            <div className="ehr-pt-value">
                                {data.Entity_Details.patientMatch.official_name}
                            </div>
                        </div>
                        <div className="ehr-pt-each-detail">
                            <div className="ehr-pt-label">DOB</div>
                            <div className="ehr-pt-value">
                                {data.Entity_Details.patientMatch.DOB}
                            </div>
                        </div>
                        <br />
                    </> : null}

                    <div className="patient-info-title">Update Patient Details</div>
                    <div className={loader ? "block-area-common" : ""} style={{ padding: "10px" }}>
                        <TextField
                            value={inputValue}
                            onChange={handleChange}
                            error={error}
                            helperText={error ? 'Invalid MRN.' : ''}
                            variant="standard"
                            placeholder="Enter MRN number"
                            sx={{ width: "260px" }}
                            focused
                            disabled={Object.keys(selectedPatient || {})?.length}
                        />
                        <button
                            className="apply-button"
                            style={{ marginLeft: '20px' }}
                            onClick={() => !error && inputValue && getMultiPatientsDetails()}
                            disabled={error}
                        >
                            <p className="apply-button-text">Search</p>
                        </button>
                    </div>
                    <TableContainer component={Paper} sx={{ maxHeight: 320, minHeight: "150px" }} style={{ textAlign: 'center' }}>
                        <Table stickyHeader aria-label="customized table">
                            <TableHead className="thBorder">
                                <TableRow>
                                    <TableCell className="tableHeadStyle">Select</TableCell>
                                    <TableCell className="tableHeadStyle">Patient Name</TableCell>
                                    <TableCell className="tableHeadStyle">DOB</TableCell>
                                    <TableCell className="tableHeadStyle">MRN</TableCell>
                                    <TableCell className="tableHeadStyle">Gender</TableCell>
                                    <TableCell className="tableHeadStyle">Phone</TableCell>
                                    <TableCell className="tableHeadStyle">Address</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {!loader && (patientList || []).map((obj, i) => (
                                    <TableRow
                                        key={i}
                                        className={selectedPatient?.MRN === obj.MRN ? "ehr-table-row-color" : "table-row"}
                                    >
                                        <TableCell className="tableCellStyle" align="left">
                                            <Checkbox
                                                size="small"
                                                checked={selectedPatient?.MRN === obj.MRN ? true : false}
                                                onChange={(event) => setPatientID(event, obj)}
                                            // disabled={props.doc_level !== "Encounter"}
                                            />
                                        </TableCell>
                                        <TableCell className="tableCellStyle" align="left">
                                            <div>{obj?.name[0] || ""}</div>
                                        </TableCell>
                                        <TableCell className="tableCellStyle" align="left">
                                            <div>{obj.dob}</div>
                                        </TableCell>
                                        <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                            <div>{obj.MRN}</div>
                                        </TableCell>
                                        <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                            <div>{obj.gender ? obj.gender : ""}</div>
                                        </TableCell>
                                        <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                            <div>{obj.phone ? obj.phone : ""}</div>
                                        </TableCell>
                                        <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                            {obj.address.length > 40 ? (
                                                <CustomTooltip title={obj.address} placement="top-start">
                                                    <div >

                                                        {obj.address.length > 40
                                                            ? obj.address.substr(0, 25) + "..."
                                                            : null}

                                                    </div>
                                                </CustomTooltip>
                                            ) : (<div>{obj.address}</div>)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {loader ? <CircularProgress size={30} className="popup-spinner" /> : (patientList?.length === 0 && <DialogModal message={apiErrorMsg} /> || null)}

                    </TableContainer>
                    <div className="div-center">
                        <button
                            className="apply-button"
                            type="submit"
                            disabled={Object.keys(selectedPatient || {})?.length == 0}
                            onClick={updatePatientInfo}
                        >
                            <p className="apply-button-text">Save</p>
                        </button>
                        <button
                            className="reset-button"
                            type="submit"
                            onClick={() => props.fetchID("cancel")}
                        >
                            <p className="reset-button-text">Cancel</p>
                        </button>
                    </div>
                </div>


            </div>

        </div>
    </>
}
export default PatientInfo;